import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

const CheckboxComponent = ({ label, name, value, onChange, disabled }) => (
  <div>
    <FormControlLabel
      control={
        <Checkbox
          checked={!!value}
          color="primary"
          name={name}
          onChange={(e) => {
            const event = {
              target: {
                name: name,
                value: e.target.checked,
              },
            };
            onChange(event);
          }}
          disabled={disabled}
        />
      }
      label={label}
    />
  </div>
);
export default CheckboxComponent;
